import axios from 'axios';

const postBankDataApi = async (values, token, langIsoCode, edit = false) => {
  const url = '/Auth_private/saveBankAccount';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default postBankDataApi;
